import React, { useRef, useState } from 'react';
import PageHero from '../layouts/PageHero';
import Image from 'next/image';
import { FAQ_CONTENT, FAQ_PAGE_INTERFACE } from '../api/faqPage';
import client from '../apollo-client';
import Faqs from '../components/Contact/Faqs';
import Header from '../components/Partner/Header';
import MidleSection from '../components/Partner/MiddleSec';
import PartnerModal from '../components/Partner/Modal';
import PartnerStepsMobile, {
  partnerSteps
} from '../components/Partner/PartnerStepsMobile';
import Thanks from '../components/Partner/Thanks';
import Head from 'next/head';

interface IProps {
  faqs: any;
}
const Partner = ({ faqs }: IProps) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openModal2, setOpenModal2] = useState<boolean>(false);
  const applyRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <Head>
        <meta name="og:title" content={'Partner - See Sight Tours'} />
        <meta
          name="og:description"
          content={'The Partner Of See Sight Tours'}
        />
        <title>Partner - See Sight Tours</title>
        <meta
          name="description"
          content={'The Partner Page Of See Sight Tours'}
        />
        <link rel="canonical" href={'https://www.seesight-tours.com/partner'} />
        <meta name="og:image" content="/vertical-seesight-logo.png" />
      </Head>
      <PageHero
        title="BECOME A See Sight Tours AFFILIATE PARTNER"
        snippet="Turn Your Love For Travel Into A Revenue Stream"
        media="https://res.cloudinary.com/see-sight-tours/image/upload/w_1440,h_500/v1683894851/Remaining%20images/Attraction/Hornblower/Hornblower_Niagara_Cruises_2_vcvgbo.jpg"
        video={false}
        partner={true}
        partnerApplyRef={applyRef}
      />
      <Header />
      <MidleSection />
      <section
        id="partnership-step"
        className="px-[5%] lg:px-[18%] pt-0 pb-8 md:py-20"
      >
        <div className="hidden md:flex gap-4 justify-between ">
          {partnerSteps.map((dt: Record<string, any>, index: number) => (
            <div key={index} className="flex-none w-[25%]  ">
              <div className="rounded-r-full rounded-l-full">
                <Image
                  src={dt.imageUrl}
                  width={200}
                  height={200}
                  alt="See Sight Tours"
                  className="w-full"
                />
              </div>
              <p className="text-center mt-5 md:text-lg lg:text-[24px] font-normal text-[#333333]">
                {dt.header}
              </p>
              <p className="text-center mt-5 text-sm lg:text-base font-normal text-[#828282] px-[6%]">
                {dt.subheader}
              </p>
            </div>
          ))}
        </div>
        <PartnerStepsMobile />
      </section>
      <section
        id="apply-now"
        className="px-[5%] lg:px-[18%] bg-[#FAFAFA] py-[2%] md:py-0"
      >
        <div className="flex justify-between md:items-center">
          <div className="flex flex-col justify-center items-center max-w-[55%] sm:max-w-[40%] py-5">
            <h3 className=" text-base md:text-lg lg:text-[28px] font-semibold text-center">
              Want To Be A Part Of Our Journey?
            </h3>
            <p className="py-3 md:pt-4 text-center px-[10%] text-xs md:text-base lg:text-[20px] font-normal">
              Apply Now And Become A Part Of Our See Sight Tours Family.
            </p>
            <button
              ref={applyRef}
              className=" p-2 lg:p-3 bg-[#1F2C5B] text-white rounded-xl text-sm lg:text-[24px] mtt-3 hover:bg-[#2E3D7A] active:bg-[#2E3D7A]"
              onClick={() => {
                setOpenModal(true);
              }}
            >
              Apply Now
            </button>
          </div>
          <div className="flex justify-center items-center w-[40%] md:w-[30%] lg:min-h-[300px] py-2 relative">
            <Image
              src={
                'https://res.cloudinary.com/see-sight-tours/image/upload/v1695198487/SST%20Website%20%28Compressed%20Images%29/partner_page/Artboard_2_svedpm.png'
              }
              alt="Pattrons"
              height={300}
              width={300}
              className="w-300 h-300"
            />
          </div>
        </div>
      </section>
      <div className="px-[3%] sm:px-[6%] md:px-[18%] mt-10 lg:mt-20 mb-[10%]">
        <Faqs
          header="Frequently Asked Questions"
          subHeader=""
          content={faqs}
          contact={true}
        />
      </div>
      {openModal && (
        <PartnerModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          openModal2={openModal2}
          setOpenModal2={setOpenModal2}
        />
      )}
      {openModal2 && (
        <Thanks openModal2={openModal2} setOpenModal2={setOpenModal2} />
      )}
    </>
  );
};
export async function getStaticProps() {
  const { data: faqs, error } = await client.query<FAQ_PAGE_INTERFACE>({
    query: FAQ_CONTENT
  });
  return {
    props: {
      faqs: [
        {
          'Where can I find more information and apply? ':
            '  To learn more about our partner program and to apply, please visit the partner page on the See Sight Tours website. If you have any questions, please contact us at affiliates@seesight-tours.com or via our social media accounts.'
        },

        {
          'Is there a fee to join the partnership?':
            'No, joining our affiliate program is completely free. There is no upfront fee or expense to become a member.'
        },

        {
          'Who can become a partner in See Sight Tours?':
            ' Anyone with a website, blog, social media, or target audience interested in travel and tourism can apply to become a partner.'
        },

        {
          ' Can I share these links on my social media site?':
            'Yes, you can share the links on your social media accounts, but you must comply with the rules and regulations of the social media platform and collaboration you use.'
        },

        {
          ' How can I verify the income I receive? ':
            'You can view and track your earnings through our affiliate control panel. Commissions are generally processed and disbursed within one month of the completion of the sale. '
        },
        {
          " Will joining this service give me access to a partner's business group?  ":
            'As a See Sight Tours affiliate, you will have access to the See Sight Tours control panel that provides access to our store. As an affiliate, you cannot register with the store unless you are a customer. However, you will be able to access the store and participate in all programs. '
        },
        {
          ' How do I get paid?  ':
            'To withdraw commission, you will need to see the See Sight Tours dashboard on your PayPal or Stripe site. You will receive payment immediately after registration is completed.  '
        },
        {
          ' How do I track my referrals? ':
            ' Your recommendations will be tracked through your unique link in the See Sight Tours control panel. You will be able to view clicks and track referrals until they close or fail during the See Sight Tours sales cycle. '
        }
      ]
    }
  };
}
export default Partner;
